export type Lang = "es" | "en";

export const translations: Record<Lang, Record<string, string>> = {
  es: {
    hero_badge: "Integrado con Telegram",
    hero_title_1: "Santy",
    hero_title_2: "¿Dónde la quieres?",
    hero_subtitle: "Sin correos. Sin vueltas.",
    photo_caption_1: "Péguese un rato ps",
    photo_caption_2: "Puedes con 3?",
    photo_caption_3: "Quien se sienta",
    photo_caption_4: "Un ratico",
    cta_title: "Únete al canal exclusivo",
    cta_subtitle: "Acceso VIP desde $30.000 COP",
    cta_button: "Unirse al canal",
    offer_title: "Grupo VIP exclusivo",
    offer_feature_1: "Más de 500+ videos disponibles",
    offer_feature_2: "Acceso VIP completo",
    offer_price_label: "Acceso VIP",
    offer_price: "$30.000",
    offer_currency: "COP",
    offer_footer: "Déjame tus datos y te escribo al privado.",
    contact_title: "directo",
    contact_subtitle: "Sin filtros, sin intermediarios. Telegram es el canal — respondo personal.",
    contact_telegram: "@santy_oficial19_bot",
    contact_phone: "",
    contact_chat_button: "Abrir chat",
    footer_text: "Aquí y ahora.",
    theme_light: "Claro",
    theme_dark: "Oscuro",
    
    // Mis Redes
    mylinks_title: "Mis Redes",
    mylinks_subtitle: "Encuéntrame en todas partes",
    mylinks_x: "X",
    mylinks_x_desc: "Diario · previews",
    mylinks_onlyfans: "OnlyFans",
    mylinks_onlyfans_desc: "VIP · exclusivo",
    mylinks_xxxfollow: "XXXFollow",
    mylinks_xxxfollow_desc: "+18 · premium",
    mylinks_instagram: "Instagram",
    mylinks_instagram_desc: "Fotos · stories",
    mylinks_tiktok: "TikTok",
    mylinks_tiktok_desc: "Cortos · trends",
    mylinks_tumblr: "Tumblr",
    mylinks_tumblr_desc: "Blog · fotos",
    mylinks_wishlist_title: "Lista de Deseos",
    mylinks_wishlist_subtitle: "¿Quieres mimarme?",
    mylinks_wishlist_desc: "Estos son algunos regalos que me harían feliz",
    mylinks_wishlist_button: "Ver Wishlist",
    mylinks_visit: "Visitar",
    mylinks_links_label: "enlaces",
    mylinks_title_1: "Mis",
    mylinks_title_2: "redes.",

    // Galería
    gallery_title: "Galería",
    gallery_subtitle: "Vista previa",
    gallery_tag: "Lo nuevo",
    gallery_fallback_caption: "Nuevo contenido.",

    // Canales
    channels_tag: "Canales · 02 disponibles",
    channels_title_1: "Elige tu",
    channels_title_2: "experiencia.",
    channels_vip_title: "EXCLUSIVO",
    channels_vip_subtitle: "· privado",
    channels_vip_desc: "Acceso ilimitado al canal premium, drops semanales y chat 1-a-1.",
    channels_stat_videos: "videos",
    channels_stat_drop: "cada drop",
    channels_stat_dm: "DM",
    channels_from: "Desde",
    channels_duration: "30 días · renovable",
    channels_contact_btn: "Contactar",
    channels_free_title: "CANAL FREE",
    channels_free_badge: "GRATIS",
    channels_free_desc: "Previews, novedades y comunidad.",
    channels_footer: "Canales",

    // Contacto
    contact_tag: "Contacto",
    contact_header_1: "Escríbeme",
    contact_header_2: "directo",
    contact_platform: "Telegram",
    contact_response_label: "Suele responder en",
    contact_response_time: "~ 12 MIN",
    contact_action_sub: "Suscribirse",
    contact_action_vip: "VIP plus",
    contact_footer: "Contacto",
    marquee_item_1: "NUEVO DROP CADA VIERNES",
    marquee_item_2: "RESPUESTA EN MENOS DE 15 MIN",
    marquee_item_3: "CANAL VIP · ACCESO INMEDIATO",
    marquee_item_4: "PAGO SEGURO POR BRE-B / PAYPAL",

    // Soporte / FAQ
    help_tag: "Soporte",
    help_title_1: "Preguntas",
    help_title_2: "frecuentes.",
    help_cta_title: "¿No encontraste tu respuesta?",
    help_cta_desc: "Escríbeme directamente por Telegram y te respondo en menos de 15 minutos.",
    help_cta_btn: "Contactar",

    // VIP Section
    vip_tag: "Membresía premium",
    vip_monthly_label: "Primer Día / Nuevo",
    vip_yearly_label: "Renovación / Recurrente",
    vip_compare_title: "Comparativa",
    vip_compare_header_feature: "Feature",
    vip_subscribe_btn: "Suscribirme ahora",
    vip_footer_note: "Pago seguro · Acceso inmediato",
    vip_feature_content: "Contenido exclusivo",
    vip_feature_content_free: "Previews",
    vip_feature_content_vip: "Todo + BTS",
    vip_feature_chat: "Chat directo",
    vip_feature_chat_free: "—",
    vip_feature_chat_vip: "1-a-1 privado",
    vip_feature_drops: "Drops semanales",
    vip_feature_drops_free: "Mensual",
    vip_feature_drops_vip: "Semanal",
    vip_feature_draws: "Sorteos",
    vip_feature_draws_free: "—",
    vip_feature_draws_vip: "Automático",
    vip_feature_priority: "Prioridad",
    vip_feature_priority_free: "Normal",
    vip_feature_priority_vip: "Primera fila",
    vip_feature_length: "Videos largos",
    vip_feature_length_free: "Clips cortos",
    vip_feature_length_vip: "Completos HD",

    // Suscripción
    subscribe_tag: "Suscripción",
    subscribe_title_1: "Pago",
    subscribe_title_2: "seguro.",
    subscribe_select_desc: "Elige tu plan para acceder al canal VIP.",
    subscribe_plan_monthly: "Primer Día / Nuevo",
    subscribe_plan_monthly_desc: "Válido hoy en tu primera interacción. 30 días de acceso.",
    subscribe_plan_yearly: "Renovación / Recurrente",
    subscribe_plan_yearly_desc: "Para usuarios recurrentes o renovaciones. 30 días de acceso.",
    subscribe_total_to_pay: "Total a pagar",
    subscribe_plan_selected: "Plan",
    subscribe_plan_monthly_val: "primer día",
    subscribe_plan_yearly_val: "renovación",
    subscribe_instructions_title: "Instrucciones BRE-B Llave",
    subscribe_step_1: "Envía desde cualquier banco en Colombia",
    subscribe_step_2: "Envía a la llave BRE-B: {TARGET}",
    subscribe_step_3: "Monto exacto: ${PRICE} {CURRENCY}",
    subscribe_step_4: "En el asunto/referencia escribe tu usuario de Telegram",
    subscribe_step_5: "Confirma y envíame el comprobante",
    subscribe_back_btn: "← Volver",
    subscribe_paid_btn: "Ya pagué ✓",
    subscribe_verifying_title: "Verificando",
    subscribe_verifying_desc: "Tu pago está siendo verificado. Serás redirigido al bot para confirmar tu acceso VIP.",

    // Registro
    register_tag: "Registro",
    register_title_1: "Únete",
    register_title_2: "ahora.",
    register_desc: "Déjame tus datos y te contacto cuando haya algo nuevo.",
    register_field_name: "Nombre",
    register_field_name_placeholder: "Tu nombre",
    register_field_name_err: "Nombre requerido",
    register_field_telegram: "Telegram",
    register_field_telegram_placeholder: "@tu_usuario",
    register_field_telegram_err: "Usuario requerido",
    register_field_telegram_err_format: "Debe empezar con @",
    register_field_country: "País",
    register_field_country_placeholder: "Seleccionar...",
    register_field_country_err: "Selecciona un país",
    register_field_interest: "Interés principal",
    register_interest_vip: "VIP Channel",
    register_interest_content: "Contenido Exclusivo",
    register_interest_collab: "Colaboraciones",
    register_interest_curious: "Solo curioso",
    register_submit_btn: "Registrarme",
    register_success_title: "¡Listo!",
    register_success_desc: "Gracias {NAME}. Te contactaré pronto por Telegram ({TELEGRAM}).",

    // FAQ
    faq_q_1: "¿Cómo funciona el canal VIP?",
    faq_a_1: "Al suscribirte recibes acceso inmediato al canal privado de Telegram. Ahí publico contenido exclusivo semanal: fotos, videos y behind-the-scenes que no encontrarás en ninguna otra plataforma.",
    faq_q_2: "¿Qué métodos de pago aceptan?",
    faq_a_2: "Aceptamos la llave BRE-B (puedes enviar desde cualquier banco en Colombia), PayPal (para usuarios internacionales) y estrellas de Telegram (100% automático). El proceso con BRE-B y PayPal es verificado por mi admin en minutos.",
    faq_q_3: "¿Puedo cancelar cuando quiera?",
    faq_a_3: "Sí, la suscripción mensual se renueva manualmente. Si no renuevas al final del periodo, simplemente pierdes acceso. Sin cargos automáticos ni penalizaciones.",
    faq_q_4: "¿Qué diferencia hay entre Free y VIP?",
    faq_a_4: "El canal Free tiene previews y novedades generales. El VIP incluye todo el contenido premium sin censura, chat 1-a-1 conmigo, drops semanales y acceso a sorteos exclusivos.",
    faq_q_5: "¿Cuánto tarda la activación?",
    faq_a_5: "Si pagas con Estrellas es automático. Si usas BRE-B o PayPal, normalmente tardo menos de 15 minutos en horario diurno después de verificar tu capture.",
    faq_q_6: "¿Puedo compartir mi acceso?",
    faq_a_6: "No. El acceso es personal e intransferible. Si detectamos uso compartido, el acceso será revocado sin reembolso.",
    faq_q_7: "¿Hay reembolsos?",
    faq_a_7: "No ofrecemos reembolsos una vez activado el acceso. Por eso te recomiendo explorar el canal Free primero para asegurarte de que el contenido es lo que buscas.",

    // Menú de Comandos (Quick Menu)
    cmd_about_label: "Sobre mí",
    cmd_about_desc: "Qué puedes hacer aquí",
    cmd_sub_label: "Suscribirse",
    cmd_sub_desc: "Activar suscripción",
    cmd_vip_label: "VIP Plus",
    cmd_vip_desc: "Acceso premium",
    cmd_profile_label: "Perfil",
    cmd_profile_desc: "Tu información",
    cmd_help_label: "Ayuda",
    cmd_help_desc: "Soporte y FAQ",
    cmd_register_label: "Registrarse",
    cmd_register_desc: "Únete a la lista",
    cmd_wishlist_label: "Wishlist",
    cmd_wishlist_desc: "Lista de deseos",
    badge_new: "NUEVO",
    commands_quick_title: "Comandos rápidos",
    commands_quick_hint: "Usa los slash · en chat o aquí",
    loading_text: "Cargando · Mini App",

    // Hero stats
    hero_skip_tour: "Saltar tour",
    hero_stat_followers: "seguidores",
    hero_stat_satisfaction: "satisfacción",
    hero_stat_countries: "países",

    // Sidebars (Desktop)
    sidebar_left_title_1: "Aquí y",
    sidebar_left_title_2: "ahora.",
    sidebar_left_desc: "Reescritura visual de App3 — shader fluid wallpaper, streaming text, organic loader y transiciones con motion. Toda la fuerza del original, con disciplina editorial.",
    sidebar_left_nav: "navegar",
    sidebar_right_tag: "Sistema",
    sidebar_right_title_1: "Crimson",
    sidebar_right_title_2: "discipline.",
    sidebar_right_desc: "WebGL shader → carbón profundo + plumas crimson. Anton ✕ Instrument Serif ✕ Space Grotesk. Listas con hairlines, números tabulares, micro-loader orgánico.",
    version_text: "v4.5 · impactante · 4 ago 2026",

    // Perfil
    profile_tag: "Tu información",
    profile_title: "Perfil",
    profile_premium: "Premium",
    profile_premium_yes: "Sí",
    profile_premium_no: "No",
    profile_platform: "Plataforma",
    profile_language: "Idioma",
    profile_status_label: "Estado",
    profile_status_not_subscribed: "NO SUSCRITO",
    profile_status_active: "ACTIVO VIP",
    profile_activate_vip_btn: "Activar VIP",

    // Wishlist
    wishlist_footer_note: "Los regalos se procesan de forma inmediata y 100% segura usando Estrellas de Telegram. Te escribiré al privado para agradecerte personalmente.",
    wishlist_send_receipt_btn: "Ir al chat",

    // Sobre mí
    about_tag: "Acerca de mí",
    about_title: "Sobre mí",
    about_subtitle: "Soy Santy. Te explico todo lo que puedes hacer en esta app.",
    about_bio: "soy santiago tengo 19 años, de bello, me gustan grande todo los culos y vergas.",
    about_feat_vip_title: "Membresía VIP",
    about_feat_vip_desc: "Acceso a mis mejores videos completos, fotos sin censura y chat 1-a-1 directo conmigo.",
    about_feat_free_title: "Canal Free",
    about_feat_free_desc: "Únete gratis para ver adelantos, enterarte de novedades y estar al día con mis posts.",
    about_feat_gallery_title: "Galería de Fotos",
    about_feat_gallery_desc: "Mira las portadas y previsualizaciones de mis lanzamientos más recientes.",
    about_feat_wishlist_title: "Lista de Deseos",
    about_feat_wishlist_desc: "Apóyame o regálame algo de mi lista de deseos de forma segura usando Telegram Stars.",
    about_feat_contact_title: "Contacto Directo",
    about_feat_contact_desc: "Escríbeme a mi Telegram personal para charlar o coordinar activaciones de forma rápida.",
    about_feat_social_title: "Redes Oficiales",
    about_feat_social_desc: "Encuentra todos mis perfiles verificados (X, Instagram, OnlyFans, TikTok, Tumblr, XXXFollow).",
  },
  en: {
    hero_badge: "Integrated with Telegram",
    hero_title_1: "Santy",
    hero_title_2: "Where do you want it?",
    hero_subtitle: "No emails. No detours.",
    photo_caption_1: "Stay a while",
    photo_caption_2: "Can you handle 3?",
    photo_caption_3: "Who's sitting?",
    photo_caption_4: "A little bit",
    cta_title: "Join the exclusive channel",
    cta_subtitle: "VIP access from $30,000 COP",
    cta_button: "Join channel",
    offer_title: "Exclusive VIP Group",
    offer_feature_1: "Over 500+ videos available",
    offer_feature_2: "Full VIP access",
    offer_price_label: "VIP Access",
    offer_price: "$30,000",
    offer_currency: "COP",
    offer_footer: "If you're interested, leave your details and I'll contact you.",
    contact_title: "direct",
    contact_subtitle: "No filters, no middlemen. Telegram is the channel — I respond personally.",
    contact_telegram: "@santy_oficial19_bot",
    contact_phone: "",
    contact_chat_button: "Open chat",
    footer_text: "Here and now.",
    theme_light: "Light",
    theme_dark: "Dark",

    // My Networks
    mylinks_title: "My Networks",
    mylinks_subtitle: "Find me everywhere",
    mylinks_x: "X",
    mylinks_x_desc: "Daily content & previews",
    mylinks_onlyfans: "OnlyFans",
    mylinks_onlyfans_desc: "Exclusive VIP content",
    mylinks_xxxfollow: "XXXFollow",
    mylinks_xxxfollow_desc: "Adult content",
    mylinks_instagram: "Instagram",
    mylinks_instagram_desc: "Photos & stories",
    mylinks_tiktok: "TikTok",
    mylinks_tiktok_desc: "Short videos",
    mylinks_tumblr: "Tumblr",
    mylinks_tumblr_desc: "Blog · photos",
    mylinks_wishlist_title: "Wishlist",
    mylinks_wishlist_subtitle: "Want to spoil me?",
    mylinks_wishlist_desc: "These are some gifts that would make me happy",
    mylinks_wishlist_button: "View Wishlist",
    mylinks_visit: "Visit",
    mylinks_links_label: "links",
    mylinks_title_1: "My",
    mylinks_title_2: "networks.",

    // Galería
    gallery_title: "Gallery",
    gallery_subtitle: "Preview",
    gallery_tag: "What's new",
    gallery_fallback_caption: "New content.",

    // Canales
    channels_tag: "Channels · 02 available",
    channels_title_1: "Choose your",
    channels_title_2: "experience.",
    channels_vip_title: "EXCLUSIVE",
    channels_vip_subtitle: "· private",
    channels_vip_desc: "Unlimited access to the premium channel, weekly drops, and 1-on-1 chat.",
    channels_stat_videos: "videos",
    channels_stat_drop: "each drop",
    channels_stat_dm: "DM",
    channels_from: "From",
    channels_duration: "30 days · renewable",
    channels_contact_btn: "Contact",
    channels_free_title: "FREE CHANNEL",
    channels_free_badge: "FREE",
    channels_free_desc: "Previews, updates, and community.",
    channels_footer: "Channels",

    // Contacto
    contact_tag: "Contact",
    contact_header_1: "Message me",
    contact_header_2: "directly",
    contact_platform: "Telegram",
    contact_response_label: "Usually responds in",
    contact_response_time: "~ 12 MIN",
    contact_action_sub: "Subscribe",
    contact_action_vip: "VIP plus",
    contact_footer: "Contact",
    marquee_item_1: "NEW DROP EVERY FRIDAY",
    marquee_item_2: "RESPONSE IN LESS THAN 15 MIN",
    marquee_item_3: "VIP CHANNEL · INSTANT ACCESS",
    marquee_item_4: "SECURE PAYPAL / STARS PAYMENT",

    // Soporte / FAQ
    help_tag: "Support",
    help_title_1: "Frequently Asked",
    help_title_2: "Questions.",
    help_cta_title: "Didn't find your answer?",
    help_cta_desc: "Message me directly on Telegram and I'll respond in less than 15 minutes.",
    help_cta_btn: "Contact",

    // VIP Section
    vip_tag: "Premium membership",
    vip_monthly_label: "First Day / New",
    vip_yearly_label: "Renewal / Recurrent",
    vip_compare_title: "Comparison",
    vip_compare_header_feature: "Feature",
    vip_subscribe_btn: "Subscribe now",
    vip_footer_note: "Secure payment · Instant access",
    vip_feature_content: "Exclusive content",
    vip_feature_content_free: "Previews",
    vip_feature_content_vip: "Everything + BTS",
    vip_feature_chat: "Direct chat",
    vip_feature_chat_free: "—",
    vip_feature_chat_vip: "1-on-1 private",
    vip_feature_drops: "Weekly drops",
    vip_feature_drops_free: "Monthly",
    vip_feature_drops_vip: "Weekly",
    vip_feature_draws: "Giveaways",
    vip_feature_draws_free: "—",
    vip_feature_draws_vip: "Automatic",
    vip_feature_priority: "Priority",
    vip_feature_priority_free: "Normal",
    vip_feature_priority_vip: "Front row",
    vip_feature_length: "Long videos",
    vip_feature_length_free: "Short clips",
    vip_feature_length_vip: "Full HD videos",

    // Suscripción
    subscribe_tag: "Subscription",
    subscribe_title_1: "Secure",
    subscribe_title_2: "payment.",
    subscribe_select_desc: "Choose your plan to access the VIP channel.",
    subscribe_plan_monthly: "First Day / New",
    subscribe_plan_monthly_desc: "Valid today on your first interaction. 30 days of access.",
    subscribe_plan_yearly: "Renewal / Recurrent",
    subscribe_plan_yearly_desc: "For recurrent users or renewals. 30 days of access.",
    subscribe_total_to_pay: "Total to pay",
    subscribe_plan_selected: "Plan",
    subscribe_plan_monthly_val: "first day",
    subscribe_plan_yearly_val: "renewal",
    subscribe_instructions_title: "PayPal Instructions",
    subscribe_step_1: "Go to your PayPal account",
    subscribe_step_2: "Send payment to: {TARGET}",
    subscribe_step_3: "Exact amount: ${PRICE} {CURRENCY}",
    subscribe_step_4: "In the reference write your Telegram username",
    subscribe_step_5: "Confirm and send me the receipt",
    subscribe_back_btn: "← Back",
    subscribe_paid_btn: "I paid ✓",
    subscribe_verifying_title: "Verifying",
    subscribe_verifying_desc: "Your payment is being verified. You will be redirected to the bot to confirm your VIP access.",

    // Registro
    register_tag: "Registration",
    register_title_1: "Join",
    register_title_2: "now.",
    register_desc: "Leave me your details and I will contact you when there is something new.",
    register_field_name: "Name",
    register_field_name_placeholder: "Your name",
    register_field_name_err: "Name required",
    register_field_telegram: "Telegram",
    register_field_telegram_placeholder: "@your_username",
    register_field_telegram_err: "Username required",
    register_field_telegram_err_format: "Must start with @",
    register_field_country: "Country",
    register_field_country_placeholder: "Select...",
    register_field_country_err: "Select a country",
    register_field_interest: "Primary interest",
    register_interest_vip: "VIP Channel",
    register_interest_content: "Exclusive Content",
    register_interest_collab: "Collaborations",
    register_interest_curious: "Just curious",
    register_submit_btn: "Register",
    register_success_title: "Success!",
    register_success_desc: "Thank you {NAME}. I will contact you soon on Telegram ({TELEGRAM}).",

    // FAQ
    faq_q_1: "How does the VIP channel work?",
    faq_a_1: "By subscribing you get instant access to the private Telegram channel. I post weekly exclusive content: photos, videos, and behind-the-scenes that you won't find on any other platform.",
    faq_q_2: "What payment methods do you accept?",
    faq_a_2: "We accept PayPal (for international users) and Telegram Stars (100% automatic). Transfers are manually verified by my admin in minutes.",
    faq_q_3: "Can I cancel at any time?",
    faq_a_3: "Yes, the monthly subscription is manually renewed. If you don't renew at the end of the period, you simply lose access. No automatic charges or fees.",
    faq_q_4: "What is the difference between Free and VIP?",
    faq_a_4: "The Free channel has previews and general updates. The VIP includes all uncensored premium content, 1-on-1 chat with me, weekly drops, and access to exclusive giveaways.",
    faq_q_5: "How long does activation take?",
    faq_a_5: "If you pay with Stars it's instant. If you use PayPal, it usually takes less than 15 minutes during daytime hours once I verify your screenshot.",
    faq_q_6: "Can I share my access?",
    faq_a_6: "No. Access is personal and non-transferable. If we detect shared usage, access will be revoked without refund.",
    faq_q_7: "Are there refunds?",
    faq_a_7: "We do not offer refunds once access is activated. That's why I recommend exploring the Free channel first to make sure the content is what you're looking for.",

    // Menú de Comandos (Quick Menu)
    cmd_about_label: "About me",
    cmd_about_desc: "What you can do here",
    cmd_sub_label: "Subscribe",
    cmd_sub_desc: "Activate subscription",
    cmd_vip_label: "VIP Plus",
    cmd_vip_desc: "Premium access",
    cmd_profile_label: "Profile",
    cmd_profile_desc: "Your information",
    cmd_help_label: "Help",
    cmd_help_desc: "Support and FAQ",
    cmd_register_label: "Register",
    cmd_register_desc: "Join the list",
    cmd_wishlist_label: "Wishlist",
    cmd_wishlist_desc: "Wishlist gifts",
    badge_new: "NEW",
    commands_quick_title: "Quick commands",
    commands_quick_hint: "Use slash commands in chat or here",
    loading_text: "Loading · Mini App",

    // Hero stats
    hero_skip_tour: "Skip tour",
    hero_stat_followers: "followers",
    hero_stat_satisfaction: "satisfaction",
    hero_stat_countries: "countries",

    // Sidebars (Desktop)
    sidebar_left_title_1: "Here and",
    sidebar_left_title_2: "now.",
    sidebar_left_desc: "Visual rewrite of App3 — shader fluid wallpaper, streaming text, organic loader and motion transitions. All the strength of the original, with editorial discipline.",
    sidebar_left_nav: "navigate",
    sidebar_right_tag: "System",
    sidebar_right_title_1: "Crimson",
    sidebar_right_title_2: "discipline.",
    sidebar_right_desc: "WebGL shader → deep coal + crimson feathers. Anton ✕ Instrument Serif ✕ Space Grotesk. Hairline lists, tabular numbers, organic micro-loader.",
    version_text: "v4.5 · striking · Aug 4, 2026",

    // Perfil
    profile_tag: "Your information",
    profile_title: "Profile",
    profile_premium: "Premium",
    profile_premium_yes: "Yes",
    profile_premium_no: "No",
    profile_platform: "Platform",
    profile_language: "Language",
    profile_status_label: "Status",
    profile_status_not_subscribed: "NOT SUBSCRIBED",
    profile_status_active: "VIP ACTIVE",
    profile_activate_vip_btn: "Activate VIP",

    // Wishlist
    wishlist_footer_note: "Gifts are processed immediately and 100% securely using Telegram Stars. I'll message you privately to thank you personally.",
    wishlist_send_receipt_btn: "Go to chat",

    // Sobre mí
    about_tag: "About me",
    about_title: "About me",
    about_subtitle: "I'm Santy. Here's everything you can do in this app.",
    about_bio: "I'm Santiago, 19 years old, from Bello, I like all big asses and cocks.",
    about_feat_vip_title: "VIP Membership",
    about_feat_vip_desc: "Access to my full videos, uncensored photos, and 1-on-1 direct chat with me.",
    about_feat_free_title: "Free Channel",
    about_feat_free_desc: "Join for free to see previews, updates, and stay in touch with my daily posts.",
    about_feat_gallery_title: "Photo Gallery",
    about_feat_gallery_desc: "Check out the covers and previews of my latest releases.",
    about_feat_wishlist_title: "Wishlist",
    about_feat_wishlist_desc: "Support me or send a gift from my wishlist safely using Telegram Stars.",
    about_feat_contact_title: "Direct Contact",
    about_feat_contact_desc: "Chat directly with my personal Telegram to connect or coordinate activations.",
    about_feat_social_title: "Official Links",
    about_feat_social_desc: "Find all of my verified social media profiles (X, Instagram, OnlyFans, TikTok, Tumblr, XXXFollow).",
  },
};
